import { SectionHeader } from "./SectionHeader"

type Props = {
  slug: string
}

/**
 * Bloque de catering en el microsite.
 *
 * NO duplica el catálogo: muestra la promesa y manda a `/[slug]/catering`, que es
 * la única vitrina. Dos razones — una sola fuente de verdad de lo que se ofrece,
 * y no meterle un bloque grande a los diez temas del hero, que tendrían que
 * absorberlo cada uno a su manera.
 *
 * Navegación normal, MISMA pestaña: el microsite y la página de catering son la
 * misma superficie pública del mismo local. La norma de abrir en pestaña nueva
 * aplica cuando el admin enlaza hacia afuera, no acá.
 */
export function CateringSection({ slug }: Props) {
  return (
    <section className="w-full max-w-3xl mx-auto px-4 py-10">
      <SectionHeader kicker="Para grupos" title="Catering" />

      <p className="text-[15px] leading-relaxed text-black/60 mt-3 max-w-xl">
        ¿Tienes un evento? Preparamos bandejas y paquetes para grupos, con
        anticipación y a la hora que los necesites.
      </p>

      <a
        href={`/${slug}/catering`}
        className="inline-flex items-center rounded-full px-5 py-2.5 mt-4 text-[14px] font-bold text-white transition-opacity hover:opacity-90"
        style={{ backgroundColor: "var(--ms-accent)" }}
      >
        Ver paquetes de catering
      </a>
    </section>
  )
}
